export const BROWSER_SUPPORT_ARTICLE_URL =
  'https://support.evisort.com/hc/en-us/articles/360044832854-System-Requirements';
